module.exports = __webpack_public_path__ + "static/media/node.cf677a9c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/node.svg
// module id = 191
// module chunks = 0